import { useState, useEffect } from "react";
import Carousel from "../components/Carousel";
import About from "./About";
import Packages from "./Packages";
import Faqs from "./Faqs";
import Questionnaire from "./Questionnaries";
import TrendingProducts from "./TrendingProducts";
import Reviews from "./Reviews";
import Products from "./Products";
// Assets
import bg1 from "../assets/bg3.mp4";
import bg2 from "../assets/bg2.jpg";
import bg3 from "../assets/bg1.jpg";
import WhatsAppButton from "./WhatsAppButton";
import Thyrocare from "./Thyrocare";
import FaqsPreview from "./FaqsPreview";
import Reproductive from "./Reproductive";
import Disposable from "./Disposable";

const Home = () => {
 const [showQuiz, setShowQuiz] = useState(false);
  const [isQuizDone, setIsQuizDone] = useState(false);

  const carouselImages = [bg1, bg2, bg3];

  const checkQuizStatus = () => {
    const userData = JSON.parse(sessionStorage.getItem("user"));
    const quizFlag = sessionStorage.getItem("quiz_completed");

    const completed = 
      userData?.is_quiz === 1 || 
      userData?.is_quiz === "1" || 
      quizFlag === "true";

    if (completed) {
      setIsQuizDone(true);
      setShowQuiz(false); 
    } else {
      setIsQuizDone(false);
      // ✅ Automatically show the quiz if not done
      setShowQuiz(true); 
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    checkQuizStatus();
  }, []);


  // ✅ FIXED: Changed min-h-fit → min-h-screen for proper stacking
  const stackSection =
    "relative md:sticky top-0 w-full min-h-screen bg-white shadow-[0_-20px_50px_rgba(0,0,0,0.1)] overflow-visible";

  const normalSection =
    "relative w-full h-fit bg-white shadow-[0_-20px_50px_rgba(0,0,0,0.1)] overflow-visible";

  return (
    <div className="relative bg-gray-50">
      <Questionnaire
        isOpen={showQuiz}
        onClose={() => setShowQuiz(false)}
      />

      {/* Layer 1: Hero */}
      <section className="sticky top-0 z-10 w-full  overflow-hidden">
        <Carousel images={carouselImages} />
      </section>

      {/* Layer 2: About */}
      <section className={`${normalSection} z-20`}>
        <div className="py-12 md:py-24">
          <About />
        </div>
      </section>
  <section className={`${normalSection} z-30`}>
        <div className="py-12 md:py-24">
         <Reproductive/>
        </div>
      </section>
       <section className={`${normalSection} z-30`}>
        <div className="py-12 md:py-24">
     <Disposable/>
        </div>
      </section>
      {/* Layer 2.5: Thyrocare */}
      <section className={`${normalSection} z-30`}>
        <div className="py-12 md:py-24">
          <Thyrocare />
        </div>
      </section>

      {/* Layer 3: Subscription Packages */}
      <section className={`${normalSection} z-40`}>
        <div className="bg-white py-10 md:py-20">
          <Packages />
        </div>
      </section>

      {/* Layer 4: Trending Products */}
      <section className={`${stackSection} z-50`}>
        <div className="py-12 md:py-24">
          <Products />
        </div>
      </section>

      {/* Layer 5: FAQs */}
      <section className={`${normalSection} z-[60]`}>
        <div className="py-12 md:py-24 bg-white">
          <FaqsPreview />
        </div>
      </section>

      {/* Layer 6: Reviews */}
      <section className="sticky top-0 z-[70] w-full min-h-[80vh] bg-white py-20 shadow-[0_-20px_50px_rgba(0,0,0,0.1)]">
        <Reviews />
      </section>

      {/* Floating Quiz Button */}
      {!isQuizDone && (
        <div className="fixed bottom-6 right-6 md:bottom-8 md:left-8 z-[100] animate-bounce">
          <button
            onClick={() => setShowQuiz(true)}
            className="bg-pink-600 text-white px-5 py-3 md:px-6 md:py-4 rounded-2xl shadow-2xl font-bold text-xs md:text-sm flex items-center gap-2 hover:bg-pink-700 transition-all border-2 border-white"
          >
            ✨ <span className="hidden xs:inline">Personalize My Flow</span>
            <span className="xs:hidden">Quiz</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;
